
import React, { useEffect, useRef, useState } from 'react';
import './homepageobject1.css';
import object1video from "./images/object1video.mp4";
import object1video2 from "./images/object1video2.mp4";
import { useLanguage } from '../../context/LanguageContext';

const HomePageObject1 = () => {
  const { t, changeLanguage } = useLanguage();
  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(entry.target);
      }
    });
  });

  useEffect(() => {
    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [ref]);

  return (
    <div className={`home-object1-container ${isVisible ? 'fade-in' : ''}`} ref={ref}>
      <div className='card1-container md:grid grid-cols-2 gap-10 text-left'>

        <video src={object1video} className='homepage-object1-video md:hidden' autoPlay muted loop playsInline></video>

        <div>
          <h1 className='homepage-card-title1'>{t("homeobject1-title1")}</h1>
          <p className='homepage-card-text2'>{t("homeobject1-text1")}</p>
          <h3 className='homepage-card-title2'>{t("homeobject1-title2")}</h3>
          <p className='homepage-card-text'>{t("homeobject1-text2")}</p>
          <h3 className='homepage-card-title2'>{t("homeobject1-title3")}</h3>
          <p className='homepage-card-text'>{t("homeobject1-text3")}</p>
          <h3 className='homepage-card-title2'>{t("homeobject1-title4")}</h3>
          <p className='homepage-card-text'>{t("homeobject1-text4")}</p>
          <h3 className='homepage-card-title2'>{t("homeobject1-title5")}</h3>
          <p className='homepage-card-text'>{t("homeobject1-text5")}</p>
        </div>

        <video src={object1video} className='homepage-object1-video object1-video-web' autoPlay muted loop playsInline></video>

      </div>

      <div className='card1-container md:grid grid-cols-2 gap-10 text-left mt-[150px]'>

        <video src={object1video2} className='homepage-object1-video2 md:hidden' autoPlay muted loop playsInline></video>

        <video src={object1video2} className='homepage-object1-video2 object1-video-web' autoPlay muted loop playsInline></video>

        <div>
          <h1 className='homepage-card-title1'>{t("homeobject1-title6")}</h1>
          <p className='homepage-card-text2'>{t("homeobject1-text6")}</p>
          <h3 className='homepage-card-title2'>{t("homeobject1-title7")}</h3>
          <p className='homepage-card-text'>{t("homeobject1-text7")}</p>
          <h3 className='homepage-card-title2'>{t("homeobject1-title8")}</h3>
          <p className='homepage-card-text'>{t("homeobject1-text8")}</p>
          <h3 className='homepage-card-title2'>{t("homeobject1-title9")}</h3>
          <p className='homepage-card-text'>{t("homeobject1-text9")}</p>
          <h3 className='homepage-card-title2'>{t("homeobject1-title10")}</h3>
          <p className='homepage-card-text'>{t("homeobject1-text10")}</p>
        </div>


      </div>
    </div>
  );
};

export default HomePageObject1;
